<template>
  
<span>

    <Menu/>

    <b-row class="mt-2">



        <b-col cols="2">


        <b-img
        :rounded="true"
        :src="auth0User.picture"
        :fluid="true"
        />


        </b-col>

        <b-col cols="10">

        <h1 class="display-4">
            Welcome, {{user.goesBy || user.firstName}}
        </h1>

        <p class="lead">
            Thank you for {{subscriptionVerb}} Principal Task.  
            
            <span v-if="subscriptionNoun === 'subscription'">
                Your {{subscriptionFrequency}} {{subscriptionNoun}} is an investment in 
                your productivity and the growth of this software.
            </span>

            <span v-if="subscriptionNoun === 'subscription'">
                Visit <b-link :href="$store.getters.getPaymentDetails.invoiceUrl" target="stripe-invoice">Stripe</b-link> 
                to download a copy of your invoice.
            </span>

        </p>

        

        <p class="lead">
            Use the menu at the top of the page to get started!
        </p>



        </b-col>

    </b-row>
		
		
</span>
</template>
<script>

  import genericOps from '../mixins/genericOps'
  import Menu from '@/components/Menu.vue'
  import UserService from '../services/UserService';


	export default {
        name: 'Welcome',
        mixins: [genericOps],
        components: {
            Menu
        },
		props: {
		},
		data () {
			return {
                auth0User: {},
                user: {},
                token: null,
                defaultImageWidth: 800,
                defaultImageHeight: 600,
                subscriptionFrequency: 'none',
                subscriptionNoun: 'membership',
                subscriptionVerb: 'joining',

            }
		},
		async created() {
        
            this.preparePage()

        },
        computed: {
            subscription: function() {

                
                return this.$store.getters.getPaymentDetails.priceId
            }
        },
        methods: {
			async preparePage() {
            
                this.loading = true

                this.token = await this.$auth.getTokenSilently()
                this.$store.dispatch('setUserToken', this.token)

                try {
                    this.auth0User = await this.$auth.user
                    this.user = await UserService.getUser(this.auth0User.email, this.token)
                    
                } catch(e) {
                    // Intentionally left blank
                }

                let id = this.$store.getters.getPaymentDetails.priceId

                this.subscriptionNoun = 'membership'
                this.subscriptionVerb = 'joining'
                
                this.validSubscriptionLevels.forEach((element, index) => {

                    if(id === element.item) {
                        this.subscriptionFrequency = element.frequency
                        this.subscriptionNoun = 'subscription'
                        this.subscriptionVerb = 'subscribing to'
                    }

                })

                if(this.subscriptionFrequency == 'month') {
                    this.subscriptionFrequency = 'monthly'
                } else if(this.subscriptionFrequency == 'quarter') {
                    this.subscriptionFrequency = 'quarterly'
                } else if(this.subscriptionFrequency == 'year') {
                    this.subscriptionFrequency = 'yearly'
                }


            }
		},    

}
</script>
<style scoped>

.loc {
    text-decoration: underline;
    font-style: oblique;
}

/* .opaque-img {
    filter: opacity(0.50)
} */

.opaque-img {
    mix-blend-mode: screen;
}

</style>